import React, { useState, useCallback } from 'react';
import {
    SelectionPanelGroup,
    SelectionPanelGroupTheme,
    SelectionPanelGroupSelectionType,
    SelectionPanelBorderRadius,
    SelectionPanelDropShadowType,
    SelectionPanelCheckShape,
    SelectionPanelCheckStyle,
    SelectionPanelGroupLayoutStyle,
} from '@apply/components';
import { DemoExample } from '../../common/DemoLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-regular-svg-icons';

/** Enhanced style (the default): bordered panels with a round check, unless checkShape says otherwise. */
export const EnhancedPanel: React.FC = () => {
    const [blueSelectionPanelSelections, set_blueSelectionPanelSelections] = useState(['3']);
    const [redSelectionPanelSelections, set_redSelectionPanelSelections] = useState(['3']);
    const [graySelectionPanelSelections, set_graySelectionPanelSelections] = useState(['3']);
    const [blueWrapSelectionPanelSelections, set_blueWrapSelectionPanelSelections] = useState(['3']);
    const [blueMultiSelectSelectionPanelSelections, set_blueMultiSelectSelectionPanelSelections] = useState(['3']);
    const [blueMultiSelectMaxLengthSelectionPanelSelections, set_blueMultiSelectMaxLengthpSelectionPanelSelections] = useState([
        '3',
    ]);
    const [squareSelections, set_squareSelections] = useState(['3']);
    const [fillSelections, set_fillSelections] = useState(['3']);
    const [squareFillSelections, set_squareFillSelections] = useState(['3']);
    const [labelVerticalSelections, set_labelVerticalSelections] = useState(['3']);
    const [labelHorizontalSelections, set_labelHorizontalSelections] = useState(['3']);
    const [labelHorizontalWrappedSelections, set_labelHorizontalWrappedSelections] = useState(['3']);

    const panelItemClick: React.MouseEventHandler = useCallback((event) => {
        alert(event.currentTarget.id + ' clicked.');
    }, []);

    const handleDeleteClick: React.MouseEventHandler = useCallback((event) => {
        alert(event.currentTarget.id + ' clicked.');
    }, []);

    const renderOption = (id: string, address: string, details: string, showIcon: boolean) => {
        return (
            <>
                <div className='item'>
                    <div className='itemContent'>
                        <div className='itemTitle'>{address}</div>
                        <div className='itemSubtitle'>{details}</div>
                    </div>
                    {showIcon && (
                        <div
                            id={`deleteOption_${id}`}
                            className='itemTrash'
                            onClick={handleDeleteClick}
                        >
                            <FontAwesomeIcon
                                color='red'
                                fontSize='20px'
                                icon={faTrashCan}
                            />
                        </div>
                    )}
                </div>
            </>
        );
    };

    //Handle Clicks can be commented in and wired to show events.
    const panelOptions = [
        {
            id: '1',
            children: renderOption('1', 'Arlington Developments', '$190,990 + Land', false),
            handleClick: panelItemClick,
        },
        {
            id: '2',
            children: renderOption('2', '1234 Commerce St Testville', '$175,000 + Land', true),
            // handleClick: panelItemClick,
        },
        {
            id: '3',
            children: renderOption('3', '8499 Sussex St, Windsor', '$240,990 + Land', false),
            // handleClick: panelItemClick,
        },
        {
            id: '4',
            children: renderOption('4', '1234 Commerce St Testville', '$175,000 + Land', false),
            // handleClick: panelItemClick,
        },
        {
            id: '5',
            children: renderOption('5', '8499 Sussex Ct, Windsor', '$240,990 + Land', false),
            // handleClick: panelItemClick,
        },
    ];

    return (
        <>
            <DemoExample label='Blue Theme'>
                <SelectionPanelGroup
                    id='blueRPDemo'
                    items={panelOptions}
                    theme={SelectionPanelGroupTheme.Blue}
                    selectedPanels={blueSelectionPanelSelections}
                    set_selectedPanels={set_blueSelectionPanelSelections}
                    borderRadius={SelectionPanelBorderRadius.Small}
                    dropShadowType={SelectionPanelDropShadowType.Small}
                    width='400px'
                />
            </DemoExample>
            <DemoExample label='Red Theme'>
                <SelectionPanelGroup
                    id='redRPDemo'
                    items={panelOptions}
                    width='400px'
                    theme={SelectionPanelGroupTheme.Red}
                    selectedPanels={redSelectionPanelSelections}
                    set_selectedPanels={set_redSelectionPanelSelections}
                    borderRadius={SelectionPanelBorderRadius.Small}
                    dropShadowType={SelectionPanelDropShadowType.Small}
                />
            </DemoExample>
            <DemoExample label='Grey Theme'>
                <SelectionPanelGroup
                    id='greyRPDemo'
                    items={panelOptions}
                    width='400px'
                    theme={SelectionPanelGroupTheme.Gray}
                    selectedPanels={graySelectionPanelSelections}
                    set_selectedPanels={set_graySelectionPanelSelections}
                    borderRadius={SelectionPanelBorderRadius.Small}
                    dropShadowType={SelectionPanelDropShadowType.Small}
                />
            </DemoExample>
            <DemoExample label='Blue Theme (Wrapped Example)'>
                <SelectionPanelGroup
                    id='bluewrappedRPDemo'
                    items={panelOptions}
                    theme={SelectionPanelGroupTheme.Blue}
                    selectedPanels={blueWrapSelectionPanelSelections}
                    set_selectedPanels={set_blueWrapSelectionPanelSelections}
                    borderRadius={SelectionPanelBorderRadius.Small}
                    dropShadowType={SelectionPanelDropShadowType.Small}
                    wrapPanels={true}
                    panelWidth='260px'
                />
            </DemoExample>
            <DemoExample label='Blue Theme (Multiselect)'>
                <SelectionPanelGroup
                    id='bluemultiselectRPDemo'
                    items={panelOptions}
                    width='400px'
                    theme={SelectionPanelGroupTheme.Blue}
                    selectedPanels={blueMultiSelectSelectionPanelSelections}
                    set_selectedPanels={set_blueMultiSelectSelectionPanelSelections}
                    borderRadius={SelectionPanelBorderRadius.Small}
                    dropShadowType={SelectionPanelDropShadowType.Small}
                    selectionType={SelectionPanelGroupSelectionType.Multiple}
                />
            </DemoExample>
            <DemoExample label='Blue Theme (Multiselect - Max 3)'>
                <SelectionPanelGroup
                    id='bluemultiselectWithMaxRPDemo'
                    items={panelOptions}
                    width='400px'
                    theme={SelectionPanelGroupTheme.Blue}
                    selectedPanels={blueMultiSelectMaxLengthSelectionPanelSelections}
                    set_selectedPanels={set_blueMultiSelectMaxLengthpSelectionPanelSelections}
                    borderRadius={SelectionPanelBorderRadius.Small}
                    dropShadowType={SelectionPanelDropShadowType.Small}
                    selectionType={SelectionPanelGroupSelectionType.Multiple}
                    maxSelection={3}
                />
            </DemoExample>
            <DemoExample label='Blue Theme (Multiselect - Square Check)'>
                <SelectionPanelGroup
                    id='blueSquareRPDemo'
                    items={panelOptions}
                    width='400px'
                    theme={SelectionPanelGroupTheme.Blue}
                    selectedPanels={squareSelections}
                    set_selectedPanels={set_squareSelections}
                    borderRadius={SelectionPanelBorderRadius.Small}
                    dropShadowType={SelectionPanelDropShadowType.Small}
                    selectionType={SelectionPanelGroupSelectionType.Multiple}
                    checkShape={SelectionPanelCheckShape.Square}
                />
            </DemoExample>
            <DemoExample label='Blue Theme (Single Select - Circle Fill)'>
                <SelectionPanelGroup
                    id='blueFillRPDemo'
                    items={panelOptions}
                    width='400px'
                    theme={SelectionPanelGroupTheme.Blue}
                    selectedPanels={fillSelections}
                    set_selectedPanels={set_fillSelections}
                    borderRadius={SelectionPanelBorderRadius.Small}
                    dropShadowType={SelectionPanelDropShadowType.Small}
                    checkStyle={SelectionPanelCheckStyle.Fill}
                />
            </DemoExample>
            <DemoExample label='Blue Theme (Single Select - Square Fill)'>
                <SelectionPanelGroup
                    id='blueSquareFillRPDemo'
                    items={panelOptions}
                    width='400px'
                    theme={SelectionPanelGroupTheme.Blue}
                    selectedPanels={squareFillSelections}
                    set_selectedPanels={set_squareFillSelections}
                    borderRadius={SelectionPanelBorderRadius.Small}
                    dropShadowType={SelectionPanelDropShadowType.Small}
                    checkShape={SelectionPanelCheckShape.Square}
                    checkStyle={SelectionPanelCheckStyle.Fill}
                />
            </DemoExample>
            <DemoExample label='Blue Theme (Single Select - With Label)'>
                <SelectionPanelGroup
                    id='blueLabelRPDemo'
                    items={panelOptions}
                    width='400px'
                    theme={SelectionPanelGroupTheme.Blue}
                    selectedPanels={labelVerticalSelections}
                    set_selectedPanels={set_labelVerticalSelections}
                    borderRadius={SelectionPanelBorderRadius.Small}
                    dropShadowType={SelectionPanelDropShadowType.Small}
                    label='Select a Budget'
                    showInfoIcon={true}
                    infoText='Choose the budget to use for this property.'
                />
            </DemoExample>
            <DemoExample label='Blue Theme (Single Select - With Label, Horizontal)'>
                <SelectionPanelGroup
                    id='blueLabelHorizontalRPDemo'
                    items={panelOptions}
                    width='550px'
                    theme={SelectionPanelGroupTheme.Blue}
                    selectedPanels={labelHorizontalSelections}
                    set_selectedPanels={set_labelHorizontalSelections}
                    borderRadius={SelectionPanelBorderRadius.Small}
                    dropShadowType={SelectionPanelDropShadowType.Small}
                    label='Select a Budget'
                    layoutStyle={SelectionPanelGroupLayoutStyle.Horizontal}
                    labelWidth='150px'
                />
            </DemoExample>
            <DemoExample label='Blue Theme (Single Select - With Label, Horizontal, Wrapped)'>
                <SelectionPanelGroup
                    id='blueLabelHorizontalWrappedRPDemo'
                    items={panelOptions}
                    theme={SelectionPanelGroupTheme.Blue}
                    selectedPanels={labelHorizontalWrappedSelections}
                    set_selectedPanels={set_labelHorizontalWrappedSelections}
                    borderRadius={SelectionPanelBorderRadius.Small}
                    dropShadowType={SelectionPanelDropShadowType.Small}
                    label='Select a Budget'
                    layoutStyle={SelectionPanelGroupLayoutStyle.Horizontal}
                    labelWidth='150px'
                    wrapPanels={true}
                    panelWidth='260px'
                />
            </DemoExample>
        </>
    );
};
